<div class="main-layout">
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
